/**
 * Determines the deep active element
 *
 * See https://developers.google.com/web/fundamentals/web-components/shadowdom#focus
 */
export function getActiveElement(): Element {
  let el = document.activeElement;
  while (el !== null && el.shadowRoot !== null && el.shadowRoot.activeElement !== null) {
    el = el.shadowRoot.activeElement;
  }

  return el;
}

/**
 * Search for and return the next focusable element.
 * All interactive content should be focusable.
 *
 * See https://www.w3.org/TR/html52/dom.html#interactive-content
 */
export function getFocusableElements(element: ParentNode): NodeListOf<Element> | null {
  return element.querySelectorAll(`
    a[href],
    audio[controls],
    button:not([disabled]),
    details,
    embed,
    iframe,
    img[usemap]
    input:not([disabled]):not([hidden]),
    label,
    select:not([disabled]),
    textarea:not([disabled]),
    video[controls],
    [tabindex]:not([tabindex="-1"])
  `);
}

export function getFirstFocusableElement(element: ParentNode): Element | null {
  const elements = getFocusableElements(element);

  return elements[0];
}

export function getLastFocusableElement(element: ParentNode): Element | null {
  const elements = getFocusableElements(element);

  return elements[elements.length - 1];
}

export function getLayoutVariants(): string[] {
  return [
    '1up-by-2up',
    '1up-by-2up-3up',
    '2up',
    '1up-by-1up-by-2up',
    '3up',
    '1-3up',
    '4up',
    '2-4up',
    '2-3up',
    '1-2-4up',
    '2up-66-33',
    '1col-narrow',
    '1col-small',
    '1col-medium',
    'side-by-side',
  ];
}

/**
 * Return the available card group variants.
 */
export function getCardGroupVariants(): string[] {
  return [
    'side-by-side',
    'three-card-step-up',
    'three-card-step-down',
    'four-card-step-up',
    'four-card-step-down',
    'custom-grid',
  ];
}

export function isDeveloperMode(): boolean {
  if (typeof document === 'undefined') {
    return false;
  }
  return document.cookie.includes('pmi_debug_yujgazfawatkzaxrlmpmukigumzmwqsn=true');
}
